import React from 'react';
import {
  addPathToList,
  Configure_screen_amount,
  Enable_additional_instructions,
  Enter_amount,
  getSubCategoryId,
  Update_amount_title,
} from '../utils/DictionaryManagementUtils';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import SwitcherPanel from '../components/PanelsComponents/Buttons/SwitcherPanel';
import { arrangeScreenInJson } from '../screens/ScreensOrdering';

//= ========================================================================
const Panel_J01_LoanUpdateAmount = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onGotoEdit,
  onStepPressed,
  language,
}) => {
  const editTextList = [
    'enter_loan_amount',
  ];
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const { amount } = globJSON.configurations.services[subCategoryId];
  const onValueChanged = (key, value) => {
    amount[key] = value;
    arrangeScreenInJson(globJSON, onConfigChanged);
  };

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      onGotoEdit={onGotoEdit}
      panelHeadline={Update_amount_title}
      panelSubHeadline={Enter_amount}
      editTextList={addPathToList(editTextList, `configurations/services/${subCategoryId}/amount/`)}
      tooltipsTitles={globJSON.configurations.services[subCategoryId].screens_ordering}
      paragraph={Configure_screen_amount}
      language={language}
    >
      <SwitcherPanel
        text={Enable_additional_instructions}
        value={amount.enable_additional_instruction}
        onValueChanged={(value) => {
          onValueChanged('enable_additional_instruction', value);
        }}
      />
    </FullPagePanel>
  );
};

export default Panel_J01_LoanUpdateAmount;
